import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Iconify from '../iconify';
import { PATH_DASHBOARD } from '../../routes/paths';

export default function ChatFab() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleChatClick = () => {
    navigate(PATH_DASHBOARD.chat);
  };

  // Hide FAB if currently on chat page
  if (location.pathname === PATH_DASHBOARD.chat) {
    return null;
  }

  return (
    <Tooltip title="Chat" placement="left">
      <Fab
        color="primary"
        aria-label="chat"
        onClick={handleChatClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 1000,
          boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
          '&:hover': {
            boxShadow: '0 12px 20px rgba(0,0,0,0.2)',
            transform: 'scale(1.05)',
          },
          transition: 'all 0.2s ease-in-out',
        }}
      >
        <Iconify icon="eva:message-circle-fill" width={24} height={24} sx={{ color: 'white' }} />
      </Fab>
    </Tooltip>
  );
}
